<template>
    <div id="hero">
        <section id="hero-section">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-sm-12">
                        <div class="row justify-content-between">
                            <div class="col-12 col-sm-12 col-md-12 order-lg-1 order-md-1">
                        <div class="intro-message pt-5 mt-5">
                            <h1 class="h1-title">We are not a family,<br>
                              we are more like a basketball team</h1>
                            <p>We love and support each other, but we also expect you to be on your best performance because we all depend on it. </p>
                            <p></p>
                            <p class="no-cv mt-5">** By the way, we don’t believe in CVs; it is never a great reflection of a human’s skills and spiritt</p>
                            <ul class="mt-2 d-flex p-0 list-unstyled">
                                <li>
                                    <router-link :to="{name: 'quiz', params: {url: 'UWX6ReHY'}}" class="btn btn-hero btn-hero-primary mr-3">Apply Now</router-link>
                                </li>
                                <li>
                                  <router-link :to="{name: 'quiz', params: {url: 'rWkA6ofJ'}}" class="btn btn-hero btn-hero-secondary d-none d-lg-block">Recommend Someone</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // import AnimatedCircles from '../AnimatedCircles.vue';

    export default {
        name: 'job-hero',
        components: {
            // 'animated-circles': AnimatedCircles,
        },
    }
</script>

<style lang="css" scoped>
    #hero-section {
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        color: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        content: "";
        z-index: 1;
        -webkit-box-align: center;
        -ms-flex-align: center;
        position: relative;
       /* background-image: url("/img/why-choose-us/background.svg"), linear-gradient(309deg, #000000 51%, #771bae);*/
      background-image: linear-gradient(309deg, #000000 51%, #771bae);
        background-attachment: fixed;
      font-size: 20px;
        background-size: cover;
    }
    .h1-title {
        font-size: 4rem !important;
    }
    .btn-hero {
        height: 48px;
        min-width: 240px;
        font-weight: bold;
        border-radius: 21px;
        cursor: pointer;
        font-size: 20px;
        border: none;
        padding-top: 10px;
    }
    .btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
        color: #ffffff;
        background-image: linear-gradient(101deg, #5b9bfb 2%, #00c092 96%) !important;
        padding-top: 10px;
        outline: none;
        border: none;
        transition: 0.3s;
    }
    .btn-hero-primary:hover {
        color: #751da7;
    }
    .no-cv{
      color: #14D1BD !important;;
    }
    .btn-hero-secondary {
        color: #751da7;
        background: #fff;
    }
    .btn-hero-secondary:hover {
        color: #751da7;
        background: #e0e0e0;
    }
    @media (max-width: 780px) {
      .h1-title {

        font-size: 2.8rem !important;
      }
        #hero-section {
            min-height: calc(100vh);
          font-size: 16px !important;
        }

        .container-fluid{

        }
    }
</style>
